<!-- Full screen overlay -->
<!-- Progress idicator -->
<div id="overlay" [ngStyle]="{'display': isLoading ? 'block' : 'none' }">
    <mat-progress-spinner class="custom-spinner" mode="indeterminate" value=25 [diameter]="65"></mat-progress-spinner>
</div>
<!-- Notification header -->
<div class="sliding-notification-header" [@notificationPanelState]="isNotificationPanelShowing">
    <div fxLayout="row" fxFlexFill>
        <div fxLayout="column" fxLayoutAlign="start left" fxFlexFill fxFlex>
            <p class="privacy-polocy-footer-body">
                {{notificationText}}
            </p>
        </div>
        <div class="close-button" fxFlexAlign="start" fxFlex="20px">
            <fa-icon (mouseup)="hideNotificationPanel()" [icon]="['far', 'times-circle']" size="lg">
            </fa-icon>
        </div>
    </div>
</div>
<!-- Page -->
<div class="body-container" fxLayout="column" fxLayoutAlign="start stretch" fxFlexFill>
    <!-- Header -->
    <div class="page-header" fxLayout="row" fxLayoutAlign="center center" fxFlex="100px">
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex>
            <div class="logo-container" fxLayout="row" fxLayoutAlign="start center" fxFlex="550px">
                <div class="monex-header-logo"></div>
            </div>
        </div>
       
    </div>
    <!--**  LANDING SCREEN OUTLET   **-->
    <div fxFlex>
        <router-outlet name="landing-screen-outlet"></router-outlet>
    </div>   
    <!-- **Sliding footer** -->
    <div class="privacy-policy-footer" [@footerPanelState]="isFooterShowing">
        <div fxLayout="row" fxFlexFill>
            <div fxLayout="column" fxLayoutAlign="start left" fxFlexFill fxFlex>
                <p class="privacy-polocy-footer-header">We value your privacy</p>
                <p class="privacy-polocy-footer-body">
                    We and our affiliates use technologies, such as cookies, and process personal data, such as
                    IP addresses and cookie identifiers, to personalize adds and content based on your interests,
                    measure performance of adds and content, and derive insights about the audience who saw adds
                    and content. Click below to constent to the use of this technology and the processing of your
                    personal data for these purposes. Your can change your mind and change your consent choices
                    at any time by returning to this site.
                </p>
            </div>
            <div class="close-button" fxFlexAlign="start" fxFlex="20px">
                <fa-icon (mouseup)="hideFooter()" [icon]="['far', 'times-circle']" size="lg">
                </fa-icon>
            </div>
        </div>
    </div>
</div>